export const WEB_ACTION_TIMEOUT_MS = 15_000;
export const WEB_BILLING_ACTION_TIMEOUT_MS = WEB_ACTION_TIMEOUT_MS;

export function withTimeout<T>(
  operation: Promise<T>,
  timeoutMs = WEB_ACTION_TIMEOUT_MS,
  timeoutMessage = "Web billing action timed out",
): Promise<T> {
  let timeoutId: ReturnType<typeof setTimeout> | undefined;

  const timeout = new Promise<never>((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(timeoutMessage));
    }, timeoutMs);
  });

  return Promise.race([operation, timeout]).finally(() => {
    if (timeoutId !== undefined) clearTimeout(timeoutId);
  });
}
